<template>
  <el-dialog
    v-model="formVisible"
    title="编辑任务"
    width="30%"
    class="editTaskDialog"
    @close="close"
  >
    <div class="content-dialog">
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        class="userForm"
      >
        <el-form-item label="任务名称" prop="">
          <el-input
            v-model="ruleForm.clueTaskName"
            placeholder="发牌机关"
          ></el-input>
        </el-form-item>
        <el-form-item label="分析倍数" prop="" class="formItem">
          <el-input v-model="ruleForm.speed" placeholder="发牌机关"></el-input>
          <span v-if="getResourcesData"
            >剩余算力/总算力：{{ getResourcesData.availablePower }}/{{
              getResourcesData.totalPower
            }}</span
          >
        </el-form-item>
      </el-form>
      <MyMap ref="mapRef" style="width: 500px; height: 300px" />
      <div class="footer">
        <h-button type="primary" @click="submit">确定</h-button>
        <h-button @click="close">取消</h-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, onMounted, reactive, toRefs, watchEffect } from "vue";
import { getResources } from "@/api/smartApplication/smartApplicationApi.js";
import MyMap from "@/components/map/MyMap.vue";
export default defineComponent({
  name: "uploadDialog",
  components: { MyMap },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    editTaskInfo: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const state = reactive({
      formVisible: false,
      ruleForm: {
        clueTaskName: "",
        speed: "",
      },
      getResourcesData: null,
    });
    const refData = toRefs(state);
    watchEffect(() => {
      state.formVisible = props.modelValue;
      state.ruleForm.clueTaskName = props.editTaskInfo.clueTaskName;
      state.ruleForm.speed = props.editTaskInfo.speed;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    const close = () => {
      context.emit("update:modelValue", false);
    };
    //获取算力
    const getResourcesAsync = async () => {
      const res = await getResources();
      state.getResourcesData = res.data;
    };
    getResourcesAsync();
    return {
      ...refData,
      close,
    };
  },
});
</script>
<style lang="scss" scoped>
.content-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  .userForm {
    width: 80%;
    .formItem {
      position: relative;
      span {
        position: absolute;
        right: 16px;
      }
    }
  }
}
</style>
